import React, { useState } from 'react';
import Formabout from '../../../Pages/Formabout';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#0f2027] via-[#203a43] to-[#2c5364] px-6 py-12 lg:px-8">
      <div className="container mx-auto">
        <h1 className="text-xl font-bold text-white mb-8 bg-[#D9C266] lg:w-[15%] w-full h-10 flex items-center pl-4 shadow-xl rounded-lg">
          <p className='text-blue-200 font-sans'>Home / Contact</p>
        </h1>

        {/* Google Map Embed */}
        <div className="relative mb-12 shadow-xl rounded-lg overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83971639966!2d77.06889797922606!3d28.527218934204768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce3b7e1a6c241%3A0x2e146348e1f0f0!2sNew%20Delhi%2C%20Delhi!5e0!3m2!1sen!2sin!4v1618902933784!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            className="rounded-lg"
          ></iframe>
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-lg pointer-events-none"></div>
        </div>

        {/* Contact Form */}
        <div className="bg-richblack-600 bg-opacity-90 p-10 rounded-lg shadow-2xl max-w-3xl mx-auto border border-transparent border-r-[#f7ff00] border-b-[#db36a4] border-t-[#fc00ff] border-l-[#00dbde]">
          <h2 className="text-4xl font-bold font-roboto text-gray-800 mb-8 text-center bg-clip-text text-transparent bg-gradient-to-r from-[#fc00ff] to-[#00dbde]">
            Get in Touch
          </h2>
          <Formabout/>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
